import {
  Airport,
  FullRequestAirHistory,
  Id,
  RequestQuoteAirRouteItinerary,
  ResumeAir,
  Timestamp
} from 'src/types'

export enum AirActionTypes {
  GET_AIR = '@air/GET_AIR',
  GET_AIR_FAILURE = '@air/GET_AIR_FAILURE',
  GET_AIR_HISTORY = '@air/GET_AIR_HISTORY',
  GET_AIR_HISTORY_FAILURE = '@air/GET_AIR_HISTORY_FAILURE',
  GET_AIR_HISTORY_SUCCESS = '@air/GET_AIR_HISTORY_SUCCESS',
  GET_AIR_SUCCESS = '@air/GET_AIR_SUCCESS',
  GET_AIRPORTS = '@air/GET_AIRPORTS',
  GET_AIRPORTS_FAILURE = '@air/GET_AIRPORTS_FAILURE',
  GET_AIRPORTS_SUCCESS = '@air/GET_AIRPORTS_SUCCESS',
  RESET_AIR = '@air/RESET_AIR'
}

export type SearchTypeType = RequestQuoteAirRouteItinerary | 'MULTI-STRETCH'

export interface GetAirType {
  customer_supplier_id?: Id
  date_end: Timestamp
  date_ini: Timestamp
  day_end?: Timestamp
  day_ini?: Timestamp
  from_airport: string
  num_adults: number
  reason_id?: Id
  searchKey: string
  searchType: SearchTypeType
  to_airport: string
}

export interface SearchType {
  error: string
  list: ResumeAir[]
  loading: boolean
  message_id: string[]
}

export interface SearchesType {
  [key: string]: SearchType
}

export type AirState = {
  readonly airportsError: boolean
  readonly airportsList: Airport[]
  readonly airportsLoading: boolean
  readonly historyError: string
  readonly historyList: FullRequestAirHistory[]
  readonly historyLoading: boolean
  readonly searches: SearchesType
  readonly searchType: SearchTypeType
}
